import { Component, ViewEncapsulation, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../app.service';
import { qmsService } from '../../app/qms/qms.service';
import { Router } from '@angular/router';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { StaticAuditTrailComponent } from '../support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { DynamicGridClauses, DynamicGridConfig, DynamicGridReport, DynamicGridSettings, DynamicGridTrail } from '../support/models/dynamic-grid.model';


export interface oneQmsUsersInterface {
  tokenId: number;
  userId: number;
  userName: string;
  firstName: string;
  lastName: string;
  isAdUser: string;
  userDescription: string;
  designationCode: string;
  departmentCode: string;
  managerId: number;
  password: string;
  emailAddress: string;
  contactNumber: string;
  country: string;
  city: string;
  timezone: string;
  primaryLanguage: string;
  secondaryLanguage: string;
  wrongLoginAttempts: number;
  lastLogonDate: Date;
  passwordResetDate: Date;
  isFactoryUser: string;
  isActive: string;
  updateReason: string;
  createdByName: string;
  createdOn: Date;
  updatedByName: string;
  updatedOn: Date;
}
export interface PopupData {
  title: string;
}
@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class UsersComponent implements OnInit {
  searchText: any;
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  isProcessing = true;
  columnname: any;
  _temp: any = {};
  columnLists: any = {};
  oneQmsUsersDataForTable1: any = [];
  addpopopData: any;
  userprivData: any = {};
  nonorgModulesData: any;
  nonorgModuleprivsData: any;
  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  dropDownForPrimaryLanguage: any;
  dropDownForSecondaryLanguage: any;
  dropDownForCountry: any;
  dropDownForTimezone: any;
  dropDownForSearchByStatus: any;
  TrainingCategorySubgroups: any;
  userId: any;
  oneQmsUsersDataForTable1Temp: any;
  dataTypeList: any = [];
  array: any = [];
  showQualitySection: any = [];
  showFormsSection: any = [];
  showTrnsSection: any = [];
  showDocsSection: any = [];
  showbpSection: any;
  oneQmsUsersDataForTable1temp: any;
  filterSearchText: string = '';
  dateCustomClasses: DatepickerDateCustomClasses[];


  constructor(public dialog: MatDialog, private readonly appService: AppService, public qmsservice: qmsService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.oneQmsUsersDataForTable1.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.oneQmsUsersDataForTable1.length, page, this.perPage, targetpage);
    this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.oneQmsUsersDataForTable1temp.length > 0) {
      this.pager = this.paginationService.getPager(this.oneQmsUsersDataForTable1temp.length, page, this.perPage, targetpage);
      this.pagedItems = this.oneQmsUsersDataForTable1temp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  oneQmsUsersDataForTable !: oneQmsUsersInterface[];
  oneQmsUsersDataForFilter !: any[];
  commonRoles: any[];
  qualityRoles: any[];
  changeRequestRoles: any[];
  capaRolesList: any = [];
  capaRoles: any[];
  deviationRoles: any[];
  auditRoles: any[];
  customerComplaiesRoles: [];
  incidentRoles: any[];
  qIssuerRoles: any[];
  oossuerRoles: any[];
  qiRoles: any = [];
  oosRoles: any = [];
  documentsRoles: any[];
  trainingsRoles: any[];
  formsLogsRoles: any[];
  bpRoles: any;
  makeStickyColumns: any;


  oddDesignationCode: any = null;
  oddDepartmentCode: any = null;
  oddTimezoneValue: any = null;
  oddCountryValue: any = null;
  oddPrimaryLanguageValue: any = null;

  onUserDeactivationChange(isDeactivated: boolean): void {
    this.oneQmsUsersFieldData.relievingDate = null;
    this.oneQmsUsersFieldData.isUserDeactivated = isDeactivated;
  }

  refreshGridData() {
    this.getcallMethod();
  }

  searchingByUserName: any = null;
  searchingByFirstName: any = null;
  searchingByLastName: any = null;
  searchingByDesignationCode: any = [];
  searchingByDepartmentCode: any = [];

  gridResetFunction() {
    this.searchingByUserName = null;
    this.searchingByFirstName = null;
    this.searchingByLastName = null;
    this.searchByemailAddress = null;
    this.designationSearchingCodeValue = null;
    this.departmentSearchingCodeValue = null;
    this.statusCodeValue = [];
    setTimeout(() => {
      this.isStatusSearchSelected = this.searchByStatusDropdown.length == this.statusCodeValue.length;
    })
    this.pager = {};
    this.pagedItems = [];
    this.columnLists.columnsListarray1 = [];
    this.oneQmsUsersDataForTable1 = [];
    this.visibleDataGrid = false;
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.isProcessing = true;
    this.oneQmsUsersDataForTable1 = [];
    const data = {

      gridName: "USERS"
    };

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "USERS",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          userName: (this.searchingByUserName && this.searchingByUserName.trim() !== "") ? this.searchingByUserName.toUpperCase() : null,
          firstName: this.searchingByFirstName == "" ? null : this.searchingByFirstName,
          lastName: this.searchingByLastName == "" ? null : this.searchingByLastName,
          emailAddress: this.searchByemailAddress == "" ? null : this.searchByemailAddress,
          designationCode: this.designationSearchingCodeValue ? this.designationSearchingCodeValue : null,
          departmentCode: this.departmentSearchingCodeValue ? this.departmentSearchingCodeValue : null,
          userStatus: (Array.isArray(this.statusCodeValue) && this.statusCodeValue.length > 0) ? this.statusCodeValue.map((item: any) => item).join(',') : null,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }

        this.reportObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.oneQmsUsersDataForTable1 = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            let arr = [];
            if (data1.columnsListarray[data1.columnsListarray.length - 1].includes("\r")) {
              arr = data1.columnsListarray[data1.columnsListarray.length - 1].split("\r");
              data1.columnsListarray[data1.columnsListarray.length - 1] = arr[0];
            }

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];

            this.columnLists.fieldColumnarray = data1.fieldColumnarray.map((fieldCol: string, p: number) => ({
              "fieldColumnarray": fieldCol,
              "width": data1.fieldSizeListArray[p] + 'px'
            }));

            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];

            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            const visibleIndices: number[] = [];
            for (const [index, colName] of this.columnLists.columnsListarray.entries()) {
              if (!this.columnLists.invisibleColumnarray.includes(colName)) {
                visibleIndices.push(index);
              }
            }

            this.columnLists.columnsListarray = visibleIndices.map(i => this.columnLists.columnsListarray[i]);
            this.columnLists.fieldColumnarray = visibleIndices.map(i => this.columnLists.fieldColumnarray[i]);
            this.columnLists.fieldSizeListArray = visibleIndices.map(i => this.columnLists.fieldSizeListArray[i]);

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];

            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;

                for (const [m, colName] of this.columnLists.columnsListarray.entries()) {
                  this.columnLists.columnsListarray1.push({
                    columnsListarray: colName,
                    dataType: "textbox",
                    width: this.columnLists.fieldSizeListArray
                  });

                  this.columnLists.fieldColumnarray[m].dataType = "textbox";

                  for (const dataTypeObj of this.dataTypeList) {
                    if (dataTypeObj.columnName === colName) {
                      this.columnLists.columnsListarray1[m].dataType = dataTypeObj.fieldType;
                      this.columnLists.fieldColumnarray[m].dataType = dataTypeObj.fieldType;
                      break;
                    }
                  }
                }

                const checkboxCols = this.dataTypeList
                  .filter((item: any) => item.fieldType === 'CHECKBOX')
                  .map((item: any) => item.columnName);

                if (Array.isArray(this.oneQmsUsersDataForTable1) && checkboxCols.length > 0) {
                  for (const row of this.oneQmsUsersDataForTable1) {
                    for (const colName of checkboxCols) {
                      if (row.hasOwnProperty(colName)) {
                        row[colName] = row[colName] === "Y";
                      }
                    }
                  }
                }

                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.setPage(1, 0);
                this.pager.totalPages = undefined;

              },
              error: (error: any) => {
                this.isProcessing = false;
                throw error;
              }
            });

            this.message.gridList = this.oneQmsUsersDataForTable1;
            this.collectionSize = this.oneQmsUsersDataForTable1.length;
            this.totalPages = Math.ceil(this.oneQmsUsersDataForTable1.length / this.itemsPerPage);

          },
          error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });

    this.visibleDataGrid = true;

    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  focusEmpty() {
    console.log();
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    const data = {
      tableName: 'ONEQMS_USERS_VW',
      moduleName: null,
      gridName: 'USERS',
      groupId: 0
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (response: any) => {
        this.label = response;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }
  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.oneQmsUsersDataForTable1.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.oneQmsUsersDataForTable1.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  /* Start row search selectbox */
  filterByStatusCode: any;
  selectedSearchStatus: any;
  onSearchStatusSelect(column: string, item: any) {
    if (this.filterByStatusCode.length > 1) {
      this.pagedItems = this.oneQmsUsersDataForTable1;
    } else {
      this.selectedSearchStatus = item.valueExp == 'active';
      if (this.selectedSearchStatus == 'all') {
        this.pagedItems = this.oneQmsUsersDataForTable1;
      } else {
        this.pagedItems = this.oneQmsUsersDataForTable1.filter((e: any) =>
          e[column] === this.selectedSearchStatus
        );
      }
    }
  }

  onSearchStatusRemoved(column: string, item: any) {
    if (this.filterByStatusCode.length == 0) {
      this.pagedItems = this.oneQmsUsersDataForTable1;
    } else {
      this.pagedItems = this.oneQmsUsersDataForTable1.filter((e: any) =>
        e[column] !== this.selectedSearchStatus
      );
    }
  }

  onSearchStatusSelectAll(item: any) {
    this.pagedItems = this.oneQmsUsersDataForTable1;
  }

  onSearchStatusDeSelectAll(item: any) {
    this.pagedItems = this.oneQmsUsersDataForTable1;
  }
  /* End row search selectbox */

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })

  }

  onClick(event: any) {
  }

  callOneQmsUserDetailsGetCall() {
    this.appService.getOneQmsUserDetails().subscribe((response: any) => {
      this.qmsservice.getOneQmsOrgUsersDetails = response;
      sessionStorage.setItem('oneQmsOrgUsersDetails', JSON.stringify(response));
    })
  }

  inActiveUserFlag: boolean;
  activeUserFlag: boolean;
  organizationPrivelegesDetails: any;
  trn: boolean;
  bp: boolean;
  filterfunction(list: any, field: any) {
    let value = list.filter((x: any) => x.moduleName === field);
    if (value.length > 0) {
      return value[0].funcRoles == undefined ? [] : value[0].funcRoles.split(",");
    } else {
      return [];
    }
  }
  filterfunctionForm(list: any, field: any) {
    let value = list.filter((x: any) => x.moduleName === field);
    if (value.length > 0) {
      return value[0].groupRoles == undefined ? [] : value[0].groupRoles.split(",");
    } else {
      return [];
    }
  }

  ngOnInit() {

    this.dropDownForSearchByStatus = [{
      codelistCode: "Active",
      codelistName: "Active"
    }, {
      codelistCode: "Inactive",
      codelistName: "Inactive"
    }, {
      codelistCode: "Deactivation Approval Pending",
      codelistName: "Deactivation Approval Pending"
    }, {
      codelistCode: "User Deactivation Rejected",
      codelistName: "User Deactivation Rejected"
    }, {
      codelistCode: "User Deactivated",
      codelistName: "User Deactivated"
    }];
    this.selectBoxeForSearchByStatus();

    this.callOneQmsUserDetailsGetCall();
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.dropDownForPrimaryLanguage = JSON.parse(sessionStorage.getItem('dropDownForPrimaryLanguage') || '{}');
    this.dropDownForSecondaryLanguage = JSON.parse(sessionStorage.getItem('dropDownForSecondaryLanguage') || '{}');
    this.dropDownForCountry = JSON.parse(sessionStorage.getItem('dropDownForCountry') || '{}');
    this.dropDownForTimezone = JSON.parse(sessionStorage.getItem('dropDownForTimezone') || '{}');
    this.TrainingCategorySubgroups = JSON.parse(sessionStorage.getItem('dropDownForTrainingCategory') || '{}');

    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();
    this.selectBoxeForPrimaryLanguage();
    this.selectBoxeForCountry();
    this.selectBoxeForTimezone();

    this.nonorgModuleprivsData = JSON.parse(sessionStorage.getItem('nonorgModulePrivssData') || '{}');
    this.nonorgModulesData = JSON.parse(sessionStorage.getItem('nonorgModulesData') || '{}');

    this.showQualitySection = this.nonorgModuleprivsData.filter((x: any) => x.moduleCode === "QTYCOMMON");
    this.showTrnsSection = this.nonorgModuleprivsData.filter((x: any) => x.moduleCode === "TRN");
    this.showDocsSection = this.nonorgModuleprivsData.filter((x: any) => x.moduleCode === "DOCS");
    this.showFormsSection = this.nonorgModuleprivsData.filter((x: any) => x.moduleCode === "FORMS");
    this.showbpSection = this.nonorgModuleprivsData.filter((x: any) => x.moduleCode === "BP");

    this.commonRoles = this.filterfunction(this.nonorgModuleprivsData, "Common");
    this.qualityRoles = this.filterfunction(this.nonorgModuleprivsData, "Quality");
    this.changeRequestRoles = this.filterfunction(this.nonorgModuleprivsData, "Change Request");
    this.capaRolesList = this.filterfunction(this.nonorgModuleprivsData, "Corrective And Preventive Actions");
    this.deviationRoles = this.filterfunction(this.nonorgModuleprivsData, "Deviation");
    this.auditRoles = this.filterfunction(this.nonorgModuleprivsData, "Audit");
    this.customerComplaiesRoles = this.filterfunction(this.nonorgModuleprivsData, "Customer Complaint");
    this.incidentRoles = this.filterfunction(this.nonorgModuleprivsData, "Incident");
    this.documentsRoles = this.filterfunction(this.nonorgModuleprivsData, "Document");
    this.trainingsRoles = this.filterfunction(this.nonorgModuleprivsData, "Training");
    this.formsLogsRoles = this.filterfunction(this.nonorgModulesData, "Forms and Logs");
    this.bpRoles = this.filterfunction(this.nonorgModulesData, "Business Process");
    this.qIssuerRoles = this.filterfunction(this.nonorgModuleprivsData, "Quality Issue");
    this.oossuerRoles = this.filterfunction(this.nonorgModuleprivsData, "Out Of Specification");

    this.appService.getOneQmsOrganizationPrivileges().subscribe((data: any) => {
      this.organizationPrivelegesDetails = data;
      this.trn = this.organizationPrivelegesDetails.trn == "Y";
      this.bp = this.organizationPrivelegesDetails.bp == "Y";
    });

    this.selectBoxes1();
    this.isProcessing = false;
    this.labelcall();
  }

  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';

  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    adaptivePosition: true,
  }

  $dynamicRelievingDateConfig() {
    return {
      ...this.commonDateConfig,
      minDate: this.oneQmsUsersFieldData.joiningDate ? new Date(this.oneQmsUsersFieldData.joiningDate) : undefined
    }
  }

  onJoiningDateChange() {
    if (this.oneQmsUsersFieldData.relievingDate && (this.oneQmsUsersFieldData.joiningDate > this.oneQmsUsersFieldData.relievingDate)) {
      this.oneQmsUsersFieldData.relievingDate = null;
    }
  }

  userNameDropdown: any = [];
  userNameDropdownSettings: IDropdownSettings = {};
  selectBoxes() {
    for (let i = 0; i < this.oneQmsUsersDataForTable.length; i++) {
      this.userNameDropdown = this.userNameDropdown.concat({
        valueExp: i + 1,
        displayExp: this.oneQmsUsersDataForTable[i].userName
      });
    }
    this.userNameDropdownSettings = {
      idField: 'valueExp',
      textField: 'displayExp',
      enableCheckAll: true,
      allowSearchFilter: true,
    };
  }

  //functionRole
  commonRolesDropdown: any = [];
  qualityRoleDropdown: any = [];
  changeRequestRolesDropdown: any = [];
  capaRolesDropdown: any = [];
  deviationRolesDropdown: any = [];
  auditRolesDropdown: any = [];
  customerComplaiesRolesDropdown: any = [];
  incidentRolesDropdown: any = [];
  qiRolesDropdown: any = [];
  oosRolesDropdown: any = [];
  documentsRolesDropdown: any = [];
  trainingsRolesDropdown: any = [];
  formsLogsRolesDropdown: any = [];
  bpRolesDropdown: any = [];
  TrainingCategorySubgroupsDropdown: any = [];
  functionRoleDropdownSettings: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  qualityRoleDropdownSettings: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  selectBoxes1() {

    const mapRoles = (source: any[], target: any[], filterFn?: (role: any) => boolean) => {
      source
        .filter(role => filterFn ? filterFn(role) : true)
        .forEach(role => target.push({ valueExp: role, displayExp: role }));
    };

    mapRoles(this.commonRoles, this.commonRolesDropdown);

    mapRoles(this.qualityRoles, this.qualityRoleDropdown, role => role !== 'Forms and Logs User');

    mapRoles(this.changeRequestRoles, this.changeRequestRolesDropdown);

    mapRoles(this.capaRolesList, this.capaRolesDropdown);

    mapRoles(this.deviationRoles, this.deviationRolesDropdown);

    mapRoles(this.auditRoles, this.auditRolesDropdown);

    mapRoles(this.customerComplaiesRoles, this.customerComplaiesRolesDropdown);

    mapRoles(this.incidentRoles, this.incidentRolesDropdown);

    mapRoles(this.qIssuerRoles, this.qiRolesDropdown);

    mapRoles(this.oossuerRoles, this.oosRolesDropdown);

    mapRoles(this.documentsRoles, this.documentsRolesDropdown);

    mapRoles(this.trainingsRoles, this.trainingsRolesDropdown);

    mapRoles(this.formsLogsRoles, this.formsLogsRolesDropdown);

    mapRoles(this.bpRoles, this.bpRolesDropdown);

    if (this.TrainingCategorySubgroups) {
      this.TrainingCategorySubgroups.forEach((subgroup: any) =>
        this.TrainingCategorySubgroupsDropdown.push({
          valueExp: subgroup.codelistCode,
          displayExp: subgroup.codelistName
        })
      );
    }

  }
  selectedUserNames: any = [];
  onItemSelect(item: any) {
    this.selectedUserNames.push(item.displayExp);
  }
  onItemRemoved(item: any) {
    this.selectedUserNames.splice(this.selectedUserNames.indexOf(item.id), 1);
  }
  onSelectAll(items: any) {
    for (const item of items) {
      this.selectedUserNames.push(item.displayExp);
    }
  }
  onDeSelectAll() {
    this.selectedUserNames = [];
    this.funcRoles = [];
  }


  @ViewChild(MatMenuTrigger) closeMultiFilterMenu: MatMenuTrigger;
  closeColumnFilterMenu() {
    this.closeMultiFilterMenu.closeMenu()
  }

  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };
  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('activeAndInActivePopup', { static: true }) activeAndInActivePopup: TemplateRef<any>;
  @ViewChild('userconfig', { static: true }) userconfig: TemplateRef<any>;
  @ViewChild('searchManager', { static: true }) searchManager: TemplateRef<any>;
  @ViewChild('reset', { static: true }) reset: TemplateRef<any>;
  @ViewChild('updateMessagePopup', { static: true }) updateMessagePopup: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleActiveAndInActivePopup: MatDialogRef<TemplateRef<any>>;
  visibleuserconfigPopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchManagerPopup: MatDialogRef<TemplateRef<any>>;
  visibleResetPopup: MatDialogRef<TemplateRef<any>>;
  visibleUpdateMessagePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  activeAndInActivePopupConfig = {
    width: 'auto',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  userPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '20px' },
  };

  searchManagerConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  resetConfig = {
    width: 'auto',
    height: 'auto',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px' },
  };

  updateMessagePopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  visibleAddAndEditPassword: boolean = true;
  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.visibleAddAndEditPassword = !this.visibleAddAndEditPassword;
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  visibleOldPasswordInResetPopup: boolean = true;
  changetypeOldPasswordInResetPopup: boolean = true;
  showOldPasswordInResetPopup() {
    this.visibleOldPasswordInResetPopup = !this.visibleOldPasswordInResetPopup;
    this.changetypeOldPasswordInResetPopup = !this.changetypeOldPasswordInResetPopup;
  }

  visibleNewPasswordInResetPopup: boolean = true;
  changetypeNewPasswordInResetPopup: boolean = true;
  showNewPasswordInResetPopup() {
    this.visibleNewPasswordInResetPopup = !this.visibleNewPasswordInResetPopup;
    this.changetypeNewPasswordInResetPopup = !this.changetypeNewPasswordInResetPopup;
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  visiblePasswordField: boolean;

  oneQmsUsersFieldData: any = {};


  statusAppearance(status: string) {
    if (!status) {
      return null;
    }

    let color = '#0f3659';
    let background = '';
    let border = '0.75px solid #0f3659';

    if (status.includes('Inactive') || status.includes('User Deactivation Rejected')) {
      color = '#FF3A29';
      background = '#FF3A291A';
      border = '0.75px solid #FF3A29';
    } else if (status.includes('Deactivation Approval Pending')) {
      color = '#FF8900';
      background = '#FF89001A';
      border = '0.75px solid #FF8900';
    } else if (status.includes('Active')) {
      color = '#00E58F';
      background = '#00E58F1A';
      border = '0.75px solid #00E58F';
    } else if (status.includes('User Deactivated')) {
      background = '#005C8A1A';
      border = '0.75px solid #005C8A1A';
    }

    return {
      color,
      background,
      border,
      'font-family': 'Poppins',
      'border-radius': '6px',
      'padding': '3px 9px',
      'font-size': '16px !important',
      'font-style': 'normal',
      'font-weight': '500',
      'line-height': '15px'
    };
  }
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSettingForSearchingByStatusCode: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
  };

  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  primaryLanguageDropdown: any = [];
  secondaryLanguageDropdown: any = [];
  countryDropdown: any = [];
  timezoneDropdown: any = [];
  searchByStatusDropdown: any = [];

  selectBoxeForSearchByStatus() {
    this.searchByStatusDropdown = this.dropDownForSearchByStatus?.map((status: any) => ({
      valueExp: status.codelistCode,
      displayExp: status.codelistName
    }))
  }
  selectBoxeForDesignationCode() {
    for (const item of this.dropDownForDesignationCode) {
      this.designationCodeDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }

  selectBoxeForDepartmentCode() {
    for (const item of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }

  selectBoxeForPrimaryLanguage() {
    for (const item of this.dropDownForPrimaryLanguage) {
      this.primaryLanguageDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }

  selectBoxeForCountry() {
    for (const item of this.dropDownForCountry) {
      this.countryDropdown.push({
        valueExp: item.codelistCode,
        displayExp: item.codelistName
      });
    }
  }

  selectBoxeForTimezone() {
    for (const item of this.dropDownForTimezone) {
      const timeZoneValues = `${item.region} | ${item.timezone} | ${item.clock}`;

      this.timezoneDropdown.push({
        valueExp: item.timezone,
        displayExp: timeZoneValues
      });
    }
  }

  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  selectedPrimaryLanguage: any;
  selectedSecondaryLanguage: any;
  selectedCountry: any;
  selectedTimezone: any;
  selectedStatus: any;

  onSecondaryLanguageSelect(item: any) {
    this.selectedSecondaryLanguage = item.valueExp;
  }
  onSecondaryLanguageRemoved(item: any) { }

  isFactoryUserToggerBoxValue: boolean;
  isAdUserToggerBoxValue: boolean;
  isFactoryUserFunction(isTagged: boolean) {
    this.isFactoryUserToggerBoxValue = isTagged;
  }

  isAdUserFunction(isTagged: boolean) {
    this.isAdUserToggerBoxValue = isTagged;
  }

  openAddPopup() {
    this.changetypeAddAndEditPassword = true;
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visiblePasswordField = true;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create User";
    this.oneQmsUsersFieldData.userName = '';
    this.oneQmsUsersFieldData.firstName = '';
    this.oneQmsUsersFieldData.lastName = '';
    this.oneQmsUsersFieldData.isAdUser = '';
    this.oneQmsUsersFieldData.managerId = null;
    this.oneQmsUsersFieldData.managerName = '';
    this.oneQmsUsersFieldData.userDescription = '';
    this.oneQmsUsersFieldData.designationCode = '';
    this.oneQmsUsersFieldData.departmentCode = '';
    this.oneQmsUsersFieldData.clientEmployeeId = '';
    this.oneQmsUsersFieldData.joiningDate = '';
    this.oneQmsUsersFieldData.relievingDate = '';
    this.oneQmsUsersFieldData.password = '';
    if (this.visibleAddAndEditPassword) {
      this.visibleAddAndEditPassword = false;
    };
    this.oneQmsUsersFieldData.emailAddress = '';
    this.oneQmsUsersFieldData.contactNumber = '';
    this.oneQmsUsersFieldData.country = '';
    this.oneQmsUsersFieldData.city = '';
    this.oneQmsUsersFieldData.primaryLanguage = '';
    this.oneQmsUsersFieldData.secondaryLanguage = '';
    this.oneQmsUsersFieldData.wrongLoginAttempts = null;
    this.oneQmsUsersFieldData.isActive = true;
    this.oneQmsUsersFieldData.isUserDeactivated = false;
    this.oneQmsUsersFieldData.isAdUser = false;
    this.oneQmsUsersFieldData.timeZone = '';
    this.isAdUserToggerBoxValue = false;
    this.selectedDesignationCode = null;
    this.selectedDepartmentCode = null;
    this.selectedTimezoneValue = null;
    this.selectedPrimaryLanguageValue = null;
    this.selectedSecondaryLanguageValue = null;
    this.selectedCountryValue = null;
    this.selectedDesignationValue = "";
    this.selectedDepartmentValue = "";
    this.oneQmsUsersFieldData.activity = {
      joiningDate: null,
      relievingDate: null
    };
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }


  selectedDesignationCode: any = null;
  selectedDepartmentCode: any = null;
  selectedTimezoneValue: any = null;
  selectedPrimaryLanguageValue: any = null;
  selectedSecondaryLanguageValue: any = null;
  selectedCountryValue: any = null;
  selectedUserId: any;
  previousData: any;

  openEditPopup(editRowData: any, editFlag: boolean) {
    this.oneQmsUsersFieldData.clientEmployeeId = '';
    this.oneQmsUsersFieldData.joiningDate = '';
    this.oneQmsUsersFieldData.relievingDate = '';
    this.previousData = editRowData;
    this.oneQmsUsersFieldData.clientEmployeeId = this.previousData.userStatus;
    this.visiblePasswordField = false;
    this.visibleReasonForUpdateField = true;
    this.selectedDesignationValue = "";
    this.selectedDepartmentValue = "";
    editRowData.UPDATE_REASON = null;
    if (editFlag) {
      this.visibleAddButton = false;
      this.visibleEditButton = true;
      this.operationFlag = 'EDIT';
      this.popupDataTitle.title = "Update User - " + editRowData.USER_NAME;
    } else {
      this.visibleAddButton = false;
      this.visibleEditButton = false;
      this.popupDataTitle.title = 'Details of User ' + editRowData.USER_NAME;
    }

    this.selectedUserId = editRowData.USER_ID;
    this.oneQmsUsersFieldData.userName = editRowData.USER_NAME;
    this.oneQmsUsersFieldData.firstName = editRowData.FIRST_NAME;
    this.oneQmsUsersFieldData.lastName = editRowData.LAST_NAME;
    this.oneQmsUsersFieldData.isAdUser = editRowData.isAdUser;
    this.oneQmsUsersFieldData.userDescription = editRowData.USER_DESCRIPTION;
    this.oneQmsUsersFieldData.designationCode = editRowData.DESIGNATION_CODE;
    this.oneQmsUsersFieldData.departmentCode = editRowData.DEPARTMENT_CODE;
    this.oneQmsUsersFieldData.timeZone = editRowData.TIMEZONE;
    this.oneQmsUsersFieldData.country = editRowData.COUNTRY;
    this.oneQmsUsersFieldData.primaryLanguage = editRowData.PRIMARY_LANGUAGE;
    this.oneQmsUsersFieldData.clientEmployeeId = editRowData.CLIENT_EMPLOYEE_ID;
    this.oneQmsUsersFieldData.joiningDate = editRowData.JOINING_DATE ? new Date(editRowData.JOINING_DATE) : null;
    this.oneQmsUsersFieldData.relievingDate = editRowData.RELIEVING_DATE ? new Date(editRowData.RELIEVING_DATE) : null;
    this.oneQmsUsersFieldData.userStatus = editRowData.USER_STATUS;
    this.oneQmsUsersFieldData.password = editRowData.PASSWORD;

    this.oneQmsUsersFieldData.activity = {
      joiningDate: editRowData.JOINING_DATE || null,
      relievingDate: editRowData.RELIEVING_DATE || null
    };
    if (editRowData.DESIGNATION_CODE) {
      this.designationCodeDropdown = [];
      this.selectBoxeForDesignationCode();
      const matchingDesignation = this.dropDownForDesignationCode?.find((item: any) => item.codelistCode == editRowData.DESIGNATION_CODE);
      if (!matchingDesignation) {
        this.oddDesignationCode = editRowData.DESIGNATION_CODE;
        this.designationCodeDropdown.push({
          valueExp: editRowData.DESIGNATION_CODE,
          displayExp: editRowData.DESIGNATION_CODE
        })
      }
      this.selectedDesignationCode = editRowData.DESIGNATION_CODE;
    } else {
      this.selectedDesignationCode = '';
    }


    if (editRowData.DEPARTMENT_CODE) {
      this.departmentCodeDropdown = [];
      this.selectBoxeForDepartmentCode();
      const matchingDepartment = this.dropDownForDepartmentCode?.find((item: any) => item.codelistCode == editRowData.DEPARTMENT_CODE);
      if (!matchingDepartment) {
        this.oddDepartmentCode = editRowData.DEPARTMENT_CODE;
        this.departmentCodeDropdown.push({
          valueExp: editRowData.DEPARTMENT_CODE,
          displayExp: editRowData.DEPARTMENT_CODE
        })
      }
      this.selectedDepartmentCode = editRowData.DEPARTMENT_CODE;
    } else {
      this.selectedDepartmentCode = null;
    }

    if (editRowData.COUNTRY) {
      this.countryDropdown = [];
      this.selectBoxeForCountry();
      const matchingCountry = this.dropDownForCountry?.find((item: any) => item.codelistCode == editRowData.COUNTRY);
      if (!matchingCountry) {
        this.oddCountryValue = editRowData.COUNTRY;
        this.countryDropdown.push({
          valueExp: editRowData.COUNTRY,
          displayExp: editRowData.COUNTRY
        })
      }
      this.selectedCountryValue = editRowData.COUNTRY;
    } else {
      this.selectedCountryValue = null;
    }

    if (editRowData.TIMEZONE) {
      this.timezoneDropdown = [];
      this.selectBoxeForTimezone();
      const matchingTimezone = this.dropDownForTimezone?.find((item: any) => item.timezone == editRowData.TIMEZONE);
      if (!matchingTimezone) {
        this.oddTimezoneValue = editRowData.TIMEZONE;
        this.timezoneDropdown.push({
          valueExp: editRowData.TIMEZONE,
          displayExp: editRowData.TIMEZONE
        })
      }
      this.selectedTimezoneValue = editRowData.TIMEZONE;
    } else {
      this.selectedTimezoneValue = null;
    }

    if (editRowData.PRIMARY_LANGUAGE) {
      this.primaryLanguageDropdown = [];
      this.selectBoxeForPrimaryLanguage();
      const matchingPrimaryLanguage = this.dropDownForPrimaryLanguage?.find((item: any) => item.codelistCode == editRowData.PRIMARY_LANGUAGE);
      if (!matchingPrimaryLanguage) {
        this.oddPrimaryLanguageValue = editRowData.PRIMARY_LANGUAGE;
        this.primaryLanguageDropdown.push({
          valueExp: editRowData.PRIMARY_LANGUAGE,
          displayExp: editRowData.PRIMARY_LANGUAGE
        })
      }
      this.selectedPrimaryLanguageValue = editRowData.PRIMARY_LANGUAGE;

    } else {
      this.selectedPrimaryLanguageValue = null;
    }
    if (editRowData.SECONDARY_LANGUAGE == null) {
      this.selectedSecondaryLanguageValue = '';
    }

    this.oneQmsUsersFieldData.password = editRowData.PASSWORD;
    this.oneQmsUsersFieldData.emailAddress = editRowData.EMAIL_ADDRESS;
    this.oneQmsUsersFieldData.contactNumber = editRowData.CONTACT_NUMBER;
    this.oneQmsUsersFieldData.city = editRowData.CITY;
    this.oneQmsUsersFieldData.wrongLoginAttempts = editRowData.WRONG_LOGIN_ATTEMPTS;
    this.oneQmsUsersFieldData.managerId = editRowData.MANAGER_ID;
    if (editRowData.MANAGER_NAME == ",  ") {
      this.oneQmsUsersFieldData.managerName = '';
    } else {
      this.oneQmsUsersFieldData.managerName = editRowData.MANAGER_NAME;
    }
    this.oneQmsUsersFieldData.isFactoryUser = editRowData.IS_FACTORY_USER;
    this.oneQmsUsersFieldData.isActive = editRowData.IS_ACTIVE;
    this.oneQmsUsersFieldData.isAdUser = editRowData.IS_AD_USER;
    this.oneQmsUsersFieldData.updateReason = editRowData.UPDATE_REASON;
    this.isAdUserToggerBoxValue = editRowData.IS_AD_USER;
    this.oneQmsUsersFieldData.isUserDeactivated = editRowData.IS_USER_DEACTIVATED

    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  updateReasonValidation() {

    const updateReason = document.getElementById('updateReason') as HTMLInputElement;
    const updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;

    if (this.operationFlag == 'EDIT') {
      updateReason.style.border = '1px solid red';
      updateReasonRequiredMsg.style.display = 'block';
    }

  }

  userName: any;
  firstName: any;
  lastName: any;
  password: any;
  updateReason: any;
  emailId: any;

  userNameValidationIcon: any;
  firstNameValidationIcon: any;
  lastNameValidationIcon: any;
  passwordValidationIcon: any;

  userNameRequiredMsg: any;
  firstNameRequiredMsg: any;
  lastNameRequiredMsg: any;
  passwordRequiredMsg: any;
  updateReasonRequiredMsg: any;
  managerRequiredMsg: any;
  relieveRequiredMsg: any;
  managerId: any;
  relieveId: any;

  emailIdValue: any;
  emailValidationIcon: any;
  emailRequiredMsg: any;
  emailErrorMsg: any;
  onEmailPaste(event: ClipboardEvent) {
    setTimeout(() => {
      this.emailValidation();
    }, 0);
  }
  emailValidation(): boolean {
    // Read from the NgModel variable instead of querying the DOM
    const email = this.oneQmsUsersFieldData?.emailAddress.trim();

    const error = document.getElementById('email-error-msg') as HTMLElement;
    const required = document.getElementById('email-required-msg') as HTMLElement;

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (error && required) {
      error.style.display = required.style.display = 'none';

      if (!email) {
        required.style.display = 'block';
        return false;
      }

      if (!regex.test(email)) {
        error.style.display = 'block';
        return false;
      }
    }

    return true;
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. [onNgModuleChange()] Id → ', fieldId);
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;

      element && (element.style.color = 'red');
      !element && console.error('Unable to find the element. [fieldValidation()] Id → ', elementId);
    });
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;

  addAndEditFunction(user: any, actionType?: string) {

    if (this.oneQmsUsersFieldData.userStatus == 'Deactivation Approval Pending') {
      if (this.getSelectedUserId == this.oneQmsUsersFieldData.managerId) {
        return this.showSnackBar("Sorry, cannot switch to the same user", 'E');
      } else {
        this.oneQmsUsersFieldData.managerId = this.getSelectedUserId;
        this.oneQmsUsersFieldData.managerName = this.getSelectedUserName;
        this.oneQmsUsersFieldData.updateReason = 'Manager Updated';
        this.visibleSearchManagerPopup.close();
      }
    }

    let domains: string[] = [];

    if (this.message.organizationDetails?.emailDomains) {
      domains = this.message.organizationDetails.emailDomains.split(',').map((d: any) => d.trim().toLowerCase());
    }

    let emailDomain: any = null;

    if (user.emailAddress?.includes('@')) {
      emailDomain = '@' + user.emailAddress.split('@')[1].toLowerCase();
    }

    if (this.oneQmsUsersFieldData.isAdUser) {
      user.userName = user.emailAddress;
    } else {
      user.userName = user.userName?.toUpperCase();
    }

    const validations = [
      { condition: !user.userName, id: 'user-name-v' },
      { condition: !user.firstName, id: 'first-name-v' },
      { condition: !user.lastName, id: 'last-name-v' },
      { condition: !user.emailAddress, id: 'email-v' },
      { condition: user.isUserDeactivated && !user.managerId, id: 'manager-v' },
      { condition: user.isUserDeactivated && !user.relievingDate, id: 'relieving-date-v' },
      { condition: this.operationFlag == 'ADD' && !user.isAdUser && !user.password, id: 'pd-v' },
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);
    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.showSnackBar("Please enter all mandatory fields", 'E');
    } else if (!this.emailValidation()) {
      console.error("Improper emailId");
      this.showSnackBar("Please enter the valid email", 'E');
    } else if (!(domains.length && domains.includes(emailDomain))) {
      this.showSnackBar("Please enter valid domain in the email", 'E');
    } else {
      if (this.operationFlag !== 'ADD' && this.selectedUserId == user.managerId) {
        this.showSnackBar("User and Manager cannot be the same", 'E');
        return;
      }
      this.isProcessing = true;
      if (this.operationFlag == 'ADD') {
        const obj = { ...user }
        obj.designationCode = this.selectedDesignationCode;
        obj.departmentCode = this.selectedDepartmentCode;
        obj.primaryLanguage = this.selectedPrimaryLanguageValue;
        obj.secondaryLanguage = this.selectedSecondaryLanguage;
        obj.country = this.selectedCountryValue;
        obj.timezone = this.selectedTimezoneValue;
        obj.isActive = obj.isActive ? 'Y' : 'N';
        obj.isAdUser = obj.isAdUser ? 'Y' : 'N';
        obj.isFactoryUser = obj.isFactoryUser ? 'Y' : 'N';
        obj.isUserDeactivated = obj.isUserDeactivated == 'N';

        const payload = {
          ...obj,
          userStatus: "Active",
          joiningDate: obj.joiningDate ? this.appService.dateZoneConvertion(new Date(obj.joiningDate)) : null,
          relievingDate: obj.relievingDate ? this.appService.dateZoneConvertion(new Date(obj.relievingDate)) : null,
          isUserDeactivated: obj.isUserDeactivated ? 'Y' : 'N',
        };

        this.appService.createOneQmsUsers(payload).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;

            if (this.displayResultType === 'S') {
              this.visibleAddAndEditPopup.close();
              this.getcallMethod();
              this.visibleDataGrid = true;
            }

            const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType === 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel === null ? this.message.breadcrumbData.secondLevel : this.message.breadcrumbData.thirdLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType === 'S' ? 'Success' : 'Error',
            });

            // Upgraded inner subscription to use the 'next' method as well
            sb.onAction().subscribe({
              next: () => {
                sb.dismiss();
              }
            });

            this.isProcessing = false;
          },
          error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        const isUpdateReasonMissing = this.oneQmsUsersFieldData.updateReason == null;

        if (isUpdateReasonMissing) {
          this.updateReasonValidation();
          this.isProcessing = false;
        } else {
          this.execute(user, actionType);
        }
      }
    }

    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  toCamelCaseObject(obj: any): any {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key
          .toLowerCase()
          .replace(/_([a-z])/g, (_, c) => c.toUpperCase()),
        value,
      ])
    );
  }

  execute(oneQmsUsersFieldData: any, actionType: any) {
    if (oneQmsUsersFieldData.managerId) {
      this.appService.getManagerDetails(oneQmsUsersFieldData.managerId).subscribe((response: any) => {
        if (response[0]?.isActive == 'Y') {
          this.update(oneQmsUsersFieldData, actionType);
        } else {
          this.showSnackBar('Manager is in ' + response[0].userStatus + ' Status', 'E');
        }
      })
    } else {
      this.update(oneQmsUsersFieldData, actionType);
    }
  }

  update(oneQmsUsersFieldData: any, actionType: string) {
    const payload = {
      ...oneQmsUsersFieldData,

      userId: this.selectedUserId,
      userName: oneQmsUsersFieldData.userName?.toUpperCase(),

      designationCode: this.selectedDesignationCode || null,
      departmentCode: this.selectedDepartmentCode || null,
      primaryLanguage: this.selectedPrimaryLanguageValue || null,
      secondaryLanguage: this.selectedSecondaryLanguageValue || null,
      country: this.selectedCountryValue || null,
      timezone: this.selectedTimezoneValue || null,

      isActive: oneQmsUsersFieldData.isActive ? 'Y' : 'N',
      isAdUser: oneQmsUsersFieldData.isAdUser ? 'Y' : 'N',
      isUserDeactivated: oneQmsUsersFieldData.isUserDeactivated ? 'Y' : 'N',

      joiningDate: oneQmsUsersFieldData.joiningDate ? this.appService.dateZoneConvertion(new Date(oneQmsUsersFieldData.joiningDate)) : null,
      relievingDate: oneQmsUsersFieldData.relievingDate ? this.appService.dateZoneConvertion(new Date(oneQmsUsersFieldData.relievingDate)) : null,

      userStatus: actionType === 'DEACTIVATION' ? 'Deactivation Approval Pending' : oneQmsUsersFieldData.userStatus
    };

    delete payload.createdOn;
    delete payload.updatedOn;
    console.log("UPDATE PAYLOAD", payload);
    this.appService.updateOneQmsUsers(payload).subscribe({
      next: (response: any) => {
        this.displayMessage = response.result;
        this.displayResultType = response.resultType;

        if (response.resultType === 'S') {
          this.visibleAddAndEditPopup.close();
          this.getcallMethod();
          this.visibleDataGrid = true;

          const isManagerSwitch = this.oneQmsUsersFieldData.userStatus === 'Deactivation Approval Pending' && actionType === 'UPDATE';
          const successMessage = isManagerSwitch ? 'Manager has been switched successfully' : response.result;

          this.showSnackBar(successMessage, 'S');
        } else {
          this.showSnackBar(response.result, response.resultType);
        }

        this.isProcessing = false;
      },
      error: (error: any) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      }
    });
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  funcRoles: any = [];
  qualityUserRoles: any = [];
  crRoles: any = [];
  //capaRole: any = [];
  dvRoles: any = [];
  auRoles: any = [];
  ccRoles: any = [];
  inRoles: any = [];
  documentUserRoles: any = [];
  trainingUserRoles: any = [];
  formsLogsUserRoles: any = [];
  bpUserRoles: any = [];
  trainingAuthorCategories: any = [];
  trainingReviewerApproverCategories: any = [];
  trainingOwnerCategories: any = [];

  configuration(list: any) {
    this.isProcessing = true;
    this.visibleReasonForUpdateField = true;
    this.selectedUserNames = [];
    this.funcRoles = [];
    this.qualityUserRoles = [];
    this.crRoles = [];
    this.capaRoles = [];
    this.dvRoles = [];
    this.auRoles = [];
    this.ccRoles = [];
    this.inRoles = [];
    this.qiRoles = [];
    this.oosRoles = [];
    this.documentUserRoles = [];
    this.trainingUserRoles = [];
    this.formsLogsUserRoles = [];
    this.bpUserRoles = [];
    this.trainingAuthorCategories = [];
    this.trainingReviewerApproverCategories = [];
    this.trainingOwnerCategories = [];
    this.userId = list.USER_ID;
    this.userprivData.isQualityUser = false;
    this.userprivData.isDocumentUser = false;
    this.userprivData.isTrainingUser = false;
    this.userprivData.isFormsAndLogsUser = false;
    this.userprivData.isBpUser = false;
    this.appService.userPrivsDetails(this.userId).subscribe({
      next: (response: any = {}) => {
        if (response) {
          response.isQualityUser = response.isQualityUser === "Y";
          response.isDocumentUser = response.isDocumentUser === "Y";
          response.isTrainingUser = response.isTrainingUser === "Y";
          response.isFormsAndLogsUser = response.isFormsAndLogsUser === "Y";
          response.isBpUser = response.isBpUser === "Y";

          this.userprivData = response;

          this.funcRoles = this.userprivData.funcRoles ? this.userprivData.funcRoles.split(",") : [];
          this.qualityUserRoles = this.userprivData.qualityUserRoles ? this.userprivData.qualityUserRoles.split(",") : [];
          this.crRoles = this.userprivData.crRoles ? this.userprivData.crRoles.split(",") : [];
          this.formsLogsUserRoles = this.userprivData.formsAndLogsRoles ? this.userprivData.formsAndLogsRoles.split(",") : [];
          this.bpUserRoles = this.userprivData.bpUserRoles ? this.userprivData.bpUserRoles.split(",") : [];
          this.capaRoles = this.userprivData.capaRoles ? this.userprivData.capaRoles.split(",") : [];
          this.dvRoles = this.userprivData.dvRoles ? this.userprivData.dvRoles.split(",") : [];
          this.auRoles = this.userprivData.auRoles ? this.userprivData.auRoles.split(",") : [];
          this.ccRoles = this.userprivData.ccRoles ? this.userprivData.ccRoles.split(",") : [];
          this.inRoles = this.userprivData.inRoles ? this.userprivData.inRoles.split(",") : [];
          this.qiRoles = this.userprivData.qiRoles ? this.userprivData.qiRoles.split(",") : [];
          this.oosRoles = this.userprivData.oosRoles ? this.userprivData.oosRoles.split(",") : [];
          this.documentUserRoles = this.userprivData.documentUserRoles ? this.userprivData.documentUserRoles.split(",") : [];
          this.trainingUserRoles = this.userprivData.trainingUserRoles ? this.userprivData.trainingUserRoles.split(",") : [];
          this.trainingAuthorCategories = this.userprivData.trainingAuthorCategories ? this.userprivData.trainingAuthorCategories.split(",") : [];
          this.trainingReviewerApproverCategories = this.userprivData.trainingReviewerApproverCategories ? this.userprivData.trainingReviewerApproverCategories.split(",") : [];
          this.trainingOwnerCategories = this.userprivData.trainingOwnerCategories ? this.userprivData.trainingOwnerCategories.split(",") : [];

          setTimeout(() => {
            this.isfunctionRoleSelected = this.commonRolesDropdown.length === this.funcRoles.length;
            this.isQualityRoleSelected = this.qualityRoleDropdown.length === this.qualityUserRoles.length;
            this.isCRRoleSelected = this.changeRequestRolesDropdown.length === this.crRoles.length;
            this.isFormAndLogsRolesSelected = this.formsLogsRolesDropdown.length === this.formsLogsUserRoles.length;
            this.isBusinessProcessRolesSelected = this.bpRolesDropdown.length === this.bpUserRoles.length;
            this.isCAPARoleSelected = this.capaRolesDropdown.length === this.capaRoles.length;
            this.isDeviationRoleSelected = this.deviationRolesDropdown.length === this.dvRoles.length;
            this.isAuditRoleSelected = this.auditRolesDropdown.length === this.auRoles.length;
            this.isCustomerCompRoleSelected = this.customerComplaiesRolesDropdown.length === this.ccRoles.length;
            this.isIncidentRoleSelected = this.incidentRolesDropdown.length === this.inRoles.length;
            this.isQIRoleSelected = this.qiRolesDropdown.length === this.qiRoles.length;
            this.isOOSRoleSelected = this.oosRolesDropdown.length === this.oosRoles.length;
            this.isDocumentRoleSelected = this.documentsRolesDropdown.length === this.documentUserRoles.length;
            this.isTrainingUserRoleSelected = this.trainingsRolesDropdown.length === this.trainingUserRoles.length;
            this.isAuthorCategoiresSelected = this.TrainingCategorySubgroupsDropdown.length === this.trainingAuthorCategories.length;
            this.isReviewAndAppCategSelected = this.TrainingCategorySubgroupsDropdown.length === this.trainingReviewerApproverCategories.length;
            this.isOwnerCategoriesSelected = this.TrainingCategorySubgroupsDropdown.length === this.trainingOwnerCategories.length;
          });

          this.userprivData.updateReason = '';
          this.isProcessing = false;
        }
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });

    this.visibleAddButton = false;
    this.visibleEditButton = false;
    this.popupDataTitle.title = list.USER_NAME + " User Privilege";
    this.visibleuserconfigPopup = this.dialog.open(this.userconfig, this.userPopupConfig);
    this.addpopopData = {};

  }

  addUserPrivileges() {
    if (!this.userprivData.updateReason) {
      this.showSnackBar('Please enter Update Reason', 'E');
      return;
    }

    if (this.userprivData.isFormsAndLogsUser) {
      const defaultRole = this.formsLogsRolesDropdown.find((item: any) =>
        item.displayExp === 'Forms and Logs Users' ||
        item.valueExp === 'FORMS_LOGS_USERS'
      );

      if (defaultRole && !this.formsLogsUserRoles.includes(defaultRole.valueExp)) {
        this.showSnackBar('Forms and Logs Users role must be selected when Forms and Logs User is enabled', 'E');
        return;
      }
    }

    this.isProcessing = true;

    const data = {
      userPrivsPk: {

      },
      userId: this.userId,
      sessionUserId: this.message.getUserId(),
      isQualityUser: this.userprivData.isQualityUser ? "Y" : "N",
      isDocumentUser: this.userprivData.isDocumentUser ? "Y" : "N",
      isTrainingUser: this.userprivData.isTrainingUser ? "Y" : "N",
      isFormsAndLogsUser: this.userprivData.isFormsAndLogsUser ? "Y" : "N",
      isBpUser: this.userprivData.isBpUser ? "Y" : "N",
      funcRoles: this.funcRoles?.join(',') ?? null,
      qualityUserRoles: this.qualityUserRoles?.join(',') ?? null,
      crRoles: this.crRoles?.join(',') ?? null,
      capaRoles: this.capaRoles?.join(',') ?? null,
      dvRoles: this.dvRoles?.join(',') ?? null,
      auRoles: this.auRoles?.join(',') ?? null,
      ccRoles: this.ccRoles?.join(',') ?? null,
      inRoles: this.inRoles?.join(',') ?? null,
      qiRoles: this.qiRoles?.join(',') ?? null,
      oosRoles: this.oosRoles?.join(',') ?? null,
      documentUserRoles: this.documentUserRoles?.join(',') ?? null,
      trainingUserRoles: this.trainingUserRoles?.join(',') ?? null,
      formsAndLogsRoles: this.formsLogsUserRoles?.join(',') ?? null,
      bpUserRoles: this.bpUserRoles?.join(",") ?? null,
      trainingAuthorCategories: this.trainingAuthorCategories?.join(',') ?? null,
      trainingReviewerApproverCategories: this.trainingReviewerApproverCategories?.join(',') ?? null,
      trainingOwnerCategories: this.trainingOwnerCategories?.join(',') ?? null,
      updateReason: this.userprivData.updateReason
    };

    this.executePrivileges(data);
  }

  executePrivileges(data: any) {
    if (this.userprivData.userPrivsPk == undefined) {
      this.appService.createuserpriv(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getcallMethod();
            this.visibleuserconfigPopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {

      this.appService.updateuserpriv(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getcallMethod();
            this.visibleuserconfigPopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelUserPrivileges() {
    this.visibleuserconfigPopup.close();
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    this.childCheckBoxs = isChecked;
    for (const row of this.oneQmsUsersDataForTable1) {
      row.childCheckBoxs = isChecked;
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.oneQmsUsersDataForTable1[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.USER_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.oneQmsUsersDataForTable1.some((list: any) => list.childCheckBoxs);
    this.priviousSelectedValue = idx;
  }

  searchManagerParentCheckBox: boolean = false;
  searchManagerChildCheckBoxs: boolean = false;
  searchManagerChildCheckBoxsMenu: boolean = false;

  searchManagerDataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;

    for (const row of this.getOneQmsUsersVwDetailsTableData) {
      row.searchManagerChildCheckBoxs = isChecked;
    }
  }

  validateNoOfDigitsFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  getSelectedUserId: any;
  getSelectedUserName: string;
  privvalue: any;
  searchManagerChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      if (this.privvalue != undefined) {
        this.getOneQmsUsersVwDetailsTableData[this.privvalue].searchManagerChildCheckBoxs = false;
      }
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
    this.privvalue = idx;
  }

  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByemailAddress: any = null;
  searchByDesignationCode: any = [];
  searchByDepartmentCode: any = [];
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  designationSearchingCodeValue: any;
  departmentSearchingCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];

  searchManagerFunction() {
    this.searchManagerChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = [];
    this.searchByDepartmentCode = [];
    this.popupDataTitle.title = "Search Manager";
    this.visibleSearchManagerPopup = this.dialog.open(this.searchManager, this.searchManagerConfig);
  }

  addManagerNameFunction() {
    this.oneQmsUsersFieldData.managerId = this.getSelectedUserId;
    this.oneQmsUsersFieldData.managerName = this.getSelectedUserName;
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Create User" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Update User" : "";
    }
    this.visibleSearchManagerPopup.close();
  }

  cancelSearchManagerFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Create User" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Update User" : "";
    }
    this.visibleSearchManagerPopup.close();
  }
  searchManagerGridDataFunction() {
    this.isProcessing = true;

    this.searchByUserName ??= '';
    const searchByUserName = this.searchByUserName.toUpperCase();

    this.searchOneQmsUserVwDetails = {
      userName: searchByUserName,
      firstName: this.searchByFirstName || null,
      lastName: this.searchByLastName || null,
      emailAddress: this.searchByemailAddress || null,
      designationCode: this.designationCodeValue || null,
      departmentCode: this.departmentCodeValue || null,
      status: "active"
    };

    this.appService.getOneQmsUsersVwDetails(this.searchOneQmsUserVwDetails).subscribe({
      next: (response: any) => {
        let userList: any[] = response || [];

        if (this.operationFlag !== 'ADD' && this.selectedUserId) {
          const currentUserId = Number(this.selectedUserId);

          userList = userList.filter(user =>
            Number(user.userId) !== currentUserId
          );
        }

        this.getOneQmsUsersVwDetailsTableData = userList;
        this.showUserSearchGrid = true;
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  resetSearchManagerGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.designationCodeValue = null;
    this.departmentCodeValue = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }

  searchGridFunction() {
    this.isProcessing = true;
    this.designationCodeValue = this.searchByDesignationCode?.[0]?.valueExp ?? null;
    this.departmentCodeValue = this.searchByDepartmentCode?.[0]?.valueExp ?? null;

    this.searchOneQmsUserVwDetails = {

      userName: this.searchByUserName.toUpperCase(),
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue
    };

  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.oneQmsUsersDataForTable1temp = this.oneQmsUsersDataForTable1;
      this.pager = this.paginationService.getPager(this.oneQmsUsersDataForTable1temp.length, 1, this.perPage, 0);
      this.pagedItems = this.oneQmsUsersDataForTable1temp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.oneQmsUsersDataForTable1 == undefined) {
        return this.oneQmsUsersDataForTable1;
      }
      if (!this.oneQmsUsersDataForTable1.length) {
        return this.oneQmsUsersDataForTable1;
      }
      if (filter) {
        this.oneQmsUsersDataForTable1temp = this.oneQmsUsersDataForTable1.filter((item: any) =>
          JSON.stringify(item).toLowerCase().includes(filter)
        );
      } else {
        this.oneQmsUsersDataForTable1temp = [...this.oneQmsUsersDataForTable1];
      }
      this.setPagedorserch(1, 0);
    }
  }

  onOldPsswordFocusout(e: any) {
    this.resetPasswordValidation();
  }

  resetPasswordValidation() {

    const newPassword = document.getElementById('reset-password') as HTMLInputElement;
    const newPasswordRequiredMsg = document.getElementById('reset-password-required-msg') as HTMLElement;

    const showError = !this.resetData.newPassword;

    newPassword.style.border = showError ? '1px solid red' : '';
    newPasswordRequiredMsg.style.display = showError ? 'block' : 'none';

  }

  resetData: any = {};
  oldPassword: string;
  resetPassword(list: any) {
    this.changetypeNewPasswordInResetPopup = true;
    this.oldPassword = list.PASSWORD;
    this.isProcessing = true;
    this.resetData.oldPassword = "";
    this.resetData.newPassword = "";
    if (this.visibleNewPasswordInResetPopup) {
      this.visibleNewPasswordInResetPopup = false;
    }
    this.resetData.userName = list.USER_NAME;
    this.popupDataTitle.title = "Reset Password for " + list.USER_NAME;
    this.visibleResetPopup = this.dialog.open(this.reset, this.resetConfig);
    this.isProcessing = false;
  }
  resetFunction(resetData: any) {

    this.isProcessing = true;

    if (!this.resetData.newPassword) {
      this.resetPasswordValidation();
      this.isProcessing = false;
      return;
    }

    resetData.userName = this.resetData.userName;
    resetData.oldPassword = this.resetData.oldPassword;
    resetData.newPassword = this.resetData.newPassword;

    this.appService.resetUserPasswordByAdminLevel(resetData).subscribe({

      next: (response: any) => {

        if (response.resultType === 'S') {
          this.visibleResetPopup.close();
          this.getcallMethod();
          this.visibleDataGrid = true;
        }

        const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: response.result,
            type: response.resultType === 'S' ? 'Success' : 'Error',
            buttonLabel: 'Ok',
            pageName: this.message.breadcrumbData.thirdLevel
              ?? this.message.breadcrumbData.secondLevel
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: response.resultType === 'S' ? 'Success' : 'Error'
        });

        sb.onAction().subscribe(() => sb.dismiss());

        this.isProcessing = false;
      },

      error: (error: any) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        console.error(error);
      }

    });

  }

  cancelresetFunction() {
    this.visibleResetPopup.close();
  }

  activeAndInActiveUsersUserId: number;
  activeUserButton: boolean;
  inActiveUserButton: boolean;
  updateReasonLable: string;
  errorLable: string;
  openActiveAndInActivePopup(activeAndInActiveRowData: any) {
    if (activeAndInActiveRowData.IS_ACTIVE) {
      this.inActiveUserButton = true;
      this.activeUserButton = false;
      this.updateReasonLable = 'Reason for Inactive';
      this.errorLable = 'reason for in active';
      this.popupDataTitle.title = "Inactive User - " + activeAndInActiveRowData.USER_NAME;
    } else {
      this.activeUserButton = true;
      this.inActiveUserButton = false;
      this.updateReasonLable = 'Reason for Active';
      this.errorLable = 'reason for active';
      this.popupDataTitle.title = "Active User - " + activeAndInActiveRowData.USER_NAME;
    }
    activeAndInActiveRowData.UPDATE_REASON = "";
    this.oneQmsUsersFieldData.updateReason = "";
    this.activeAndInActiveUsersUserId = activeAndInActiveRowData.USER_ID;
    this.visibleActiveAndInActivePopup = this.dialog.open(this.activeAndInActivePopup, this.activeAndInActivePopupConfig);
  }

  activeAndInActiveUsersValidation() {
    const updateReason = document.getElementById('updateReason') as HTMLInputElement;
    const updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;

    if (this.oneQmsUsersFieldData.updateReason == "") {
      updateReason.style.border = '1px solid red';
      updateReasonRequiredMsg.style.display = 'block';
    } else {
      updateReason.style.border = 'none';
      updateReasonRequiredMsg.style.display = 'none';
    }
  }

  activeAndInActiveUsers: any;
  activeAndInActiveFunction() {
    this.isProcessing = true;
    if (this.oneQmsUsersFieldData.updateReason == "") {
      this.activeAndInActiveUsersValidation();
      this.isProcessing = false;
    } else {
      this.activeAndInActiveUsers = {

        userId: this.activeAndInActiveUsersUserId,
        updateReason: this.oneQmsUsersFieldData.updateReason,
      };
      this.appService.activeAndInActiveUser(this.activeAndInActiveUsers).subscribe({

        next: (response: any) => {

          this.displayMessage = response.result;
          this.displayResultType = response.resultType;

          if (this.displayResultType === 'S') {
            this.visibleActiveAndInActivePopup.close();
            this.getcallMethod();
            this.visibleDataGrid = true;
          }

          const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: response.result,
              type: response.resultType === 'S' ? 'Success' : 'Error',
              buttonLabel: 'Ok'
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: response.resultType === 'S' ? 'Success' : 'Error'
          });

          sb.onAction().subscribe(() => sb.dismiss());

          this.isProcessing = false;
        },

        error: (error: any) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          console.error(error);
        }

      });
    }

  }

  cancelActiveAndInActiveFunction() {
    this.visibleActiveAndInActivePopup.close();
  }

  @ViewChild('uploadImagesPopup1', { static: true }) uploadImagesPopup1: TemplateRef<any>;
  visibleUploadImagesPopup1: MatDialogRef<TemplateRef<any>>;
  uploadImagesPopupConfig = {
    width: 'auto',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  imageToUpload: File | null = null;
  imageExtention: any;
  uploadSuccessMsg: any;
  uploadSuccessIcon: any;
  uploadErrorMsg: any;
  uploadErrorIcon: any;
  uploadRequiredMsg: any;
  uploadRequiredIcon: any;
  uploadUserProfileLogo: any;
  openUserImageUploadPopup(editRowDataForLogo: any) {
    this.profileImage = null;
    this.imageToUpload = null;
    this.uploadUserProfileLogo = editRowDataForLogo;

    this.popupDataTitle.title = "User Profile";
    this.visibleUploadImagesPopup1 = this.dialog.open(this.uploadImagesPopup1, this.uploadImagesPopupConfig);
  }
  profileImage: any;
  readURL(event: any): void {

    const file = event.target?.files?.[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        this.profileImage = reader.result;
      };

      reader.readAsDataURL(file);
    }

  }
  logosizeextended = false;

  uploadImages(e: any) {

    this.imageExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();

    this.uploadSuccessMsg = document.getElementById('logo-success-msg') as HTMLInputElement;
    this.uploadSuccessIcon = document.getElementById('logo-success-icon') as HTMLInputElement;

    this.uploadErrorMsg = document.getElementById('logo-error-msg') as HTMLInputElement;
    this.uploadErrorIcon = document.getElementById('logo-error-icon') as HTMLInputElement;

    this.uploadRequiredMsg = document.getElementById('logo-required-msg') as HTMLInputElement;
    this.uploadRequiredIcon = document.getElementById('logo-required-icon') as HTMLInputElement;

    if (this.imageExtention != "jpg" && this.imageExtention != "png" && this.imageExtention != "jpeg") {
      this.uploadSuccessMsg.style.display = 'none';
      this.uploadSuccessIcon.style.display = 'none';

      this.uploadErrorMsg.style.display = 'block';
      this.uploadErrorIcon.style.display = 'block';

      this.uploadRequiredMsg.style.display = 'none';
      this.uploadRequiredIcon.style.display = 'none';
    } else {
      this.uploadErrorMsg.style.display = 'none';
      this.uploadErrorIcon.style.display = 'none';

      this.uploadRequiredMsg.style.display = 'none';
      this.uploadRequiredIcon.style.display = 'none';
    }


    const file: File = e.target.files[0];
    this.imageToUpload = file;
    const maxSizeInBytes: number = 1 * 500 * 500; // 5 MB
    let FileSizeAllowToupload = false;
    if (file.size > maxSizeInBytes) {

      this.logosizeextended = true;

      FileSizeAllowToupload = true;
    }

    if (file && !FileSizeAllowToupload) {
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "IMAGE");
      formData.append("fileName", name);
      formData.append("extension", extension);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData).subscribe({

        next: (data: any) => {

          this.isProcessing = false;

          if (data.resultType === 'S') {

            this.uploadSuccessMsg.style.display = 'block';
            this.uploadSuccessIcon.style.display = 'block';

          } else {

            const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType === 'S' ? 'Success' : 'Error',
                buttonLabel: 'Ok'
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType === 'S' ? 'Success' : 'Error'
            });

            sb.onAction().subscribe(() => sb.dismiss());

          }

        },

        error: (error: any) => {

          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;

          console.error(error);

        }

      });
    }
  }

  uploadImagesValidation() {
    this.uploadSuccessMsg = document.getElementById('logo-success-msg') as HTMLInputElement;
    this.uploadSuccessIcon = document.getElementById('logo-success-icon') as HTMLInputElement;

    this.uploadErrorMsg = document.getElementById('logo-error-msg') as HTMLInputElement;
    this.uploadErrorIcon = document.getElementById('logo-error-icon') as HTMLInputElement;

    this.uploadRequiredMsg = document.getElementById('logo-required-msg') as HTMLInputElement;
    this.uploadRequiredIcon = document.getElementById('logo-required-icon') as HTMLInputElement;

    if (this.imageToUpload == null || this.imageToUpload == undefined) {
      this.uploadSuccessMsg.style.display = 'none';
      this.uploadSuccessIcon.style.display = 'none';

      this.uploadErrorMsg.style.display = 'none';
      this.uploadErrorIcon.style.display = 'none';

      this.uploadRequiredMsg.style.display = 'block';
      this.uploadRequiredIcon.style.display = 'block';
    }
  }

  uploadLogoImage() {

    this.isProcessing = true;

    if (!this.imageToUpload) {
      this.uploadImagesValidation();
      this.isProcessing = false;
      return;
    }

    const orgId = this.message.getOrgId();
    const userId = +this.uploadUserProfileLogo?.USER_ID;

    const isUpdate = !!this.qmsservice.getOneQmsOrgUsersDetails;

    const dataValues = {
      orgId,
      userId,
      operation: isUpdate ? 'U' : 'I',
      userImageExtn: isUpdate
        ? this.qmsservice.getOneQmsOrgUsersDetails.imageExtention
        : this.imageExtention
    };

    const formData = new FormData();
    formData.append('file', this.imageToUpload);

    const blob = new Blob([JSON.stringify(dataValues)], {
      type: 'application/json'
    });

    formData.append('oneQmsUserDetailsDto', blob);

    const request$ = isUpdate
      ? this.appService.updateUserImage(formData)
      : this.appService.addUserImage(formData);

    request$.subscribe({

      next: (response: any) => {

        this.displayMessage = response.result;
        this.displayResultType = response.resultType;

        const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: response.result,
            type: response.resultType === 'S' ? 'Success' : 'Error',
            buttonLabel: 'Ok'
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: response.resultType === 'S' ? 'Success' : 'Error'
        });

        sb.onAction().subscribe(() => sb.dismiss());

        this.callOneQmsUserDetailsGetCall();
        this.visibleUploadImagesPopup1.close();
        this.isProcessing = false;

      },

      error: (error: any) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        console.error(error);
      }

    });

  }

  cancelUploadLogoFunction() {
    this.imageToUpload = null;
    this.visibleUploadImagesPopup1.close();
  }

  isQualityUserChanged(event: any) {
    if (!event.checked) {
      this.qualityUserRoles = [];
      this.crRoles = [];
      this.capaRoles = [];
      this.dvRoles = [];
      this.auRoles = [];
      this.inRoles = [];
      this.qiRoles = [];
      this.ccRoles = [];
      this.oosRoles = [];
    }
  }
  isFormsAndLogsChanged(event: any) {
    if (!event.checked) {
      // Clear fields when turned OFF
      this.formsLogsUserRoles = [];
    } else {
      // Optional: Set default role when turned ON (preserving your existing logic)
      const defaultRole = this.formsLogsRolesDropdown.find((item: any) =>
        item.displayExp === 'Forms and Logs Users' || item.valueExp === 'FORMS_LOGS_USERS'
      );
      if (defaultRole && !this.formsLogsUserRoles.includes(defaultRole.valueExp)) {
        this.formsLogsUserRoles = [defaultRole.valueExp];
      }
    }
  }
  isDocumentsUserChanged(event: any) {
    if (!event.checked) {
      this.documentUserRoles = [];
    }
  }

  isTrainingsUserChanged(event: any) {
    if (!event.checked) {
      this.trainingUserRoles = [];
      this.trainingAuthorCategories = [];
      this.trainingReviewerApproverCategories = [];
      this.trainingOwnerCategories = [];
      this.isTrainingUserRoleSelected = this.isAuthorCategoiresSelected = this.isReviewAndAppCategSelected = false;
    }
  }

  isBpUserChanged(event: any) {
    if (!event.checked) {
      this.bpUserRoles = [];
    }
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel
          ?? this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild('trailPopup', { static: true }) trailPopup: TemplateRef<any>;
  visibleTrailPopup: MatDialogRef<TemplateRef<any>>;
  trailPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  closeTrailPopup() {
    this.visibleTrailPopup.close();
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;
  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, user: any, trail: any) {
    if (trail == 'USER') {
      this.auditTrail.refNo = viewType == 'overAll' ? null : user.USER_ID;
      this.auditTrail.gridName = 'USERS';
      this.auditTrail.report_And_Popup_Name = viewType == 'overAll' ? 'User Audit Trail' : (user.USER_NAME + ' Audit Trail');
      this.dynamicAuditTrailComponent.triggerTrail(user);
    } else {
      this.visibleTrailPopup = this.dialog.open(this.trailPopup, this.trailPopupConfig);
    }
  }

  auditTrailBlocks(index: number) {

    const $DB_FrontFields = 'CREATED_TS,END_TS,ACTION_FLAG,';
    const $DB_RearFields = 'UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON';

    const $DBList_Mapping: Record<number, string> = {
      0: `${$DB_FrontFields}FUNC_ROLES,IS_QUALITY_USER,QUALITY_USER_ROLES,CR_ROLES,CAPA_ROLES,DV_ROLES,AU_ROLES,CC_ROLES,IN_ROLES,QI_ROLES,FORMS_AND_LOGS_ROLES,BP_USER_ROLES,IS_DOCUMENT_USER,DOCUMENT_USER_ROLES,IS_TRAINING_USER,TRAINING_USER_ROLES,TRAINING_AUTHOR_CATEGORIES,TRAINING_REVIEWER_APPROVER_CATEGORIES,${$DB_RearFields}`,
      1: `${$DB_FrontFields}IS_QUALITY_USER,QUALITY_USER_ROLES,CR_ROLES,CAPA_ROLES,DV_ROLES,AU_ROLES,CC_ROLES,IN_ROLES,QI_ROLES,${$DB_RearFields}`,
      2: `${$DB_FrontFields}IS_TRAINING_USER,TRAINING_USER_ROLES,TRAINING_AUTHOR_CATEGORIES,TRAINING_REVIEWER_APPROVER_CATEGORIES,${$DB_RearFields}`,
      3: `${$DB_FrontFields}IS_DOCUMENT_USER,DOCUMENT_USER_ROLES,${$DB_RearFields}`,
      4: `${$DB_FrontFields}FORMS_AND_LOGS_ROLES,${$DB_RearFields}`,
      5: `${$DB_FrontFields}BP_USER_ROLES,${$DB_RearFields}`,
    };

    const $UI_Report_FrontFields = 'Created Timestamp,End Timestamp,Action Flag,';
    const $UI_Report_RearFields = 'Updated On,Updated By User,Update Reason';

    const $UIList_Mapping: Record<number, string> = {
      0: `${$UI_Report_FrontFields}Functional Roles,Is Quality User,Quality User Roles,CR Roles,CAPA Roles,DV Roles,AU Roles,CC Roles,IN Roles,QI Roles,Forms and Logs Roles,Business Process Roles,Is Document User,Document User Roles,Is Training User,Training User Roles,Training Author Categories,Training Reviewer Approver Categories,${$UI_Report_RearFields}`,
      1: `${$UI_Report_FrontFields}Is Quality User,Quality User Roles,CR Roles,CAPA Roles,DV Roles,AU Roles,CC Roles,IN Roles,QI Roles,${$UI_Report_RearFields}`,
      2: `${$UI_Report_FrontFields}Is Training User,Training User Roles,Training Author Categories,Training Reviewer Approver Categories,${$UI_Report_RearFields}`,
      3: `${$UI_Report_FrontFields}Is Document User,Document User Roles,${$UI_Report_RearFields}`,
      4: `${$UI_Report_FrontFields}Forms and Logs Roles,${$UI_Report_RearFields}`,
      5: `${$UI_Report_FrontFields}Business Process Roles,${$UI_Report_RearFields}`,
    };

    const $ReportList_Mapping: Record<number, string> = {
      0: `${$UI_Report_FrontFields}Functional Roles,Is Quality User,Quality User Roles,CR Roles,CAPA Roles,DV Roles,AU Roles,CC Roles,IN Roles,QI Roles,Forms and Logs Roles,Business Process Roles,Is Document User,Document User Roles,Is Training User,Training User Roles,Training Author Categories,Training Reviewer Approver Categories,${$UI_Report_RearFields}`,
      1: `${$UI_Report_FrontFields}Is Quality User,Quality User Roles,CR Roles,CAPA Roles,DV Roles,AU Roles,CC Roles,IN Roles,QI Roles,${$UI_Report_RearFields}`,
      2: `${$UI_Report_FrontFields}Is Training User,Training User Roles,Training Author Categories,Training Reviewer Approver Categories,${$UI_Report_RearFields}`,
      3: `${$UI_Report_FrontFields}Is Document User,Document User Roles,${$UI_Report_RearFields}`,
      4: `${$UI_Report_FrontFields}Forms and Logs Roles,${$UI_Report_RearFields}`,
      5: `${$UI_Report_FrontFields}Business Process Roles,${$UI_Report_RearFields}`,
    };

    const $Title_Mapping: Record<number, string> = {
      0: 'OverAll User Privilege(s)', 1: 'QMS User Privilege(s)', 2: 'TMS User Privilege(s)', 3: 'DMS User Privilege(s)', 4: 'Forms and Logs User Privilege(s)', 5: "Business Process User Privilege(s)"
    };

    this.message.tableOrView_Name = 'ONEQMS_USER_PRIVS_AU_VW';
    this.message.columnList_DB = $DBList_Mapping[index];
    this.message.columnList_UI = $UIList_Mapping[index];
    this.message.whereClause_AU = " AND USER_ID = " + this.userId;
    this.message.columnList_Report = $ReportList_Mapping[index];
    this.message.whereClause_Report = " WHERE USER_ID = " + this.userId;
    this.message.report_And_Popup_Name = $Title_Mapping[index] + ' Audit Trail';
    this.staticAuditTrailComponent.triggerTrail(0);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'OneQms Users Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;
  reportPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  reportType: string = "";
  openUserPrivlegesReport(reportType: any) {
    this.reportType = reportType;
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
  }

  closeUserPrivilegesReport() {
    this.visibleReportPopup.close();
  }

  reportBlocks(index: number) {

    const $DB_FrontFields = 'USER_NAME,USER_FULLNAME,FIRST_NAME,LAST_NAME,IS_ACTIVE,MANAGER_NAME,EMAIL_ADDRESS,DEPARTMENT,DESIGNATION,';
    const $DB_RearFields = 'UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON';

    const $DBList_Mapping: Record<number, string> = {
      0: `${$DB_FrontFields}FUNC_ROLES,IS_QUALITY_USER,QUALITY_USER_ROLES,CR_ROLES,CAPA_ROLES,DV_ROLES,AU_ROLES,CC_ROLES,IN_ROLES,QI_ROLES,FORMS_AND_LOGS_ROLES,BP_USER_ROLES,IS_DOCUMENT_USER,DOCUMENT_USER_ROLES,IS_TRAINING_USER,TRAINING_USER_ROLES,TRAINING_AUTHOR_CATEGORIES,TRAINING_REVIEWER_APPROVER_CATEGORIES,${$DB_RearFields}`,
      1: `${$DB_FrontFields}IS_QUALITY_USER,QUALITY_USER_ROLES,CR_ROLES,CAPA_ROLES,DV_ROLES,AU_ROLES,CC_ROLES,IN_ROLES,QI_ROLES,${$DB_RearFields}`,
      2: `${$DB_FrontFields}IS_TRAINING_USER,TRAINING_USER_ROLES,TRAINING_AUTHOR_CATEGORIES,TRAINING_REVIEWER_APPROVER_CATEGORIES,${$DB_RearFields}`,
      3: `${$DB_FrontFields}IS_DOCUMENT_USER,DOCUMENT_USER_ROLES,${$DB_RearFields}`,
      4: `${$DB_FrontFields}FORMS_AND_LOGS_ROLES,${$DB_RearFields}`,
      5: `${$DB_FrontFields}BP_USER_ROLES,${$DB_RearFields}`,
    };

    const $UI_Report_FrontFields = 'User Name,User FullName,First Name,Last Name,Is ACtive,Manager Name,Email Address,Department,Designation,';
    const $UI_Report_RearFields = 'Updated On,Updated By User,Update Reason';

    const $ReportList_Mapping: Record<number, string> = {
      0: `${$UI_Report_FrontFields}Functional Roles,Is Quality User,Quality User Roles,CR Roles,CAPA Roles,DV Roles,AU Roles,CC Roles,IN Roles,QI Roles,Forms and Logs Roles,Business Process Roles,Is Document User,Document User Roles,Is Training User,Training User Roles,Training Author Categories,Training Reviewer Approver Categories,${$UI_Report_RearFields}`,
      1: `${$UI_Report_FrontFields}Is Quality User,Quality User Roles,CR Roles,CAPA Roles,DV Roles,AU Roles,CC Roles,IN Roles,QI Roles,${$UI_Report_RearFields}`,
      2: `${$UI_Report_FrontFields}Is Training User,Training User Roles,Training Author Categories,Training Reviewer Approver Categories,${$UI_Report_RearFields}`,
      3: `${$UI_Report_FrontFields}Is Document User,Document User Roles,${$UI_Report_RearFields}`,
      4: `${$UI_Report_FrontFields}Forms and Logs Roles,${$UI_Report_RearFields}`,
      5: `${$UI_Report_FrontFields}Business Process Roles,${$UI_Report_RearFields}`,
    };

    const $Title_Mapping: Record<number, string> = {
      0: 'OverAll User Privilege(s)', 1: 'QMS User Privilege(s)', 2: 'TMS User Privilege(s)', 3: 'DMS User Privilege(s)', 4: 'Forms and Logs User Privilege(s)', 5: "Business Process User Privilege(s)"
    };

    this.excelPdf.tableOrView_Name = 'ONEQMS_USER_PRIVS_VW';
    this.excelPdf.columnList_DB = $DBList_Mapping[index];
    this.excelPdf.columnList_Report = $ReportList_Mapping[index];
    this.excelPdf.whereClause_Report = " WHERE USER_ID = " + this.userId;
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'OneQms ' + $Title_Mapping[index] + ' Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(this.reportType);
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }



  designationsearchTxt: any;

  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedDesignationValue = item.valueExp;
      } else {
        this.selectedDesignationValue = undefined;
      }
    }

  }


  departmentsearchTxt: any;

  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedDepartmentValue = item.valueExp;
      } else {
        this.selectedDepartmentValue = undefined;
      }
    }

  }



  timeZonesearchTxt: any;

  onTimeZoneSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedTimezoneValue = item.valueExp;
      } else {
        this.selectedTimezoneValue = undefined;
      }
    }

  }




  countrysearchTxt: any;

  onCountrySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedCountryValue = item.valueExp;
      } else {
        this.selectedCountryValue = undefined;
      }
    }
  }



  primarylanguagesearchTxt: any;

  onPrimaryLanguageSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedPrimaryLanguageValue = item.valueExp;
      } else {
        this.selectedPrimaryLanguageValue = undefined;
      }
    }

  }



  //NewDropDown
  statusSearchText: string = '';
  functionalRolesSearchText: string = '';
  qualityRolesSearchText: string = '';
  crRolesSearchText: string = '';
  capaRolesSearchText: string = '';
  deviationRolesSearchText: string = '';
  auditRolesSearchText: string = '';
  customerCompRolesSearchText: string = '';
  incidentRolesSearchText: string = '';
  qiRolesSearchText: string = '';
  oosRolesSearchText: string = '';
  documentRolesSearchText: string = '';
  trainingUserRolesSearchText: string = '';
  authorCategoiresSearchText: string = '';
  reviewAndAppCategSearchText: string = '';
  ownerCategoriesSearchText: string = '';
  formAndLogsRolesSearchText: string = '';
  businessProcessRolesSearchText: string = '';


  @ViewChild('statusSearch') statusSearch: MatSelect;
  @ViewChild('functionRoles') functionRoles: MatSelect;
  @ViewChild('qualityRole') qualityRole: MatSelect;
  @ViewChild('capaRole') capaRole: MatSelect;
  @ViewChild('crRole') crRole: MatSelect;
  @ViewChild('deviationRole') deviationRole: MatSelect;
  @ViewChild('auditRole') auditRole: MatSelect;
  @ViewChild('customerComplaintRole') customerComplaintRole: MatSelect;
  @ViewChild('incidentRole') incidentRole: MatSelect;
  @ViewChild('qiRole') qiRole: MatSelect;
  @ViewChild('oosRole') oosRole: MatSelect;
  @ViewChild('documentRole') documentRole: MatSelect;
  @ViewChild('trainingUserRole') trainingUserRole: MatSelect;
  @ViewChild('authorCategoires') authorCategoires: MatSelect;
  @ViewChild('reviewAndAppCateg') reviewAndAppCateg: MatSelect;
  @ViewChild('ownerCategories') ownerCategories: MatSelect;
  @ViewChild('formAndLogsRoles') formAndLogsRoles: MatSelect;
  @ViewChild('businessProcessRoles') businessProcessRoles: MatSelect;


  isStatusSearchSelected = false;
  isfunctionRoleSelected = false;
  isQualityRoleSelected = false;
  isCRRoleSelected = false;
  isCAPARoleSelected = false;
  isDeviationRoleSelected = false;
  isAuditRoleSelected = false;
  isCustomerCompRoleSelected = false;
  isIncidentRoleSelected = false;
  isQIRoleSelected = false;
  isOOSRoleSelected = false;
  isDocumentRoleSelected = false;
  isTrainingUserRoleSelected = false;
  isAuthorCategoiresSelected = false;
  isReviewAndAppCategSelected = false;
  isOwnerCategoriesSelected = false;
  isFormAndLogsRolesSelected = false;
  isBusinessProcessRolesSelected = false;
  toggleAllSelectionOthers(value: string) {

    const config: Record<string, { selected: boolean; options: any }> = {
      searchStatus: { selected: this.isStatusSearchSelected, options: this.statusSearch?.options },
      functionalRoles: { selected: this.isfunctionRoleSelected, options: this.functionRoles?.options },
      qualityRole: { selected: this.isQualityRoleSelected, options: this.qualityRole?.options },
      crRole: { selected: this.isCRRoleSelected, options: this.crRole?.options },
      capaRole: { selected: this.isCAPARoleSelected, options: this.capaRole?.options },
      deviationRoles: { selected: this.isDeviationRoleSelected, options: this.deviationRole?.options },
      auditRoles: { selected: this.isAuditRoleSelected, options: this.auditRole?.options },
      customerCompRoles: { selected: this.isCustomerCompRoleSelected, options: this.customerComplaintRole?.options },
      incidentRoles: { selected: this.isIncidentRoleSelected, options: this.incidentRole?.options },
      qiRoles: { selected: this.isQIRoleSelected, options: this.qiRole?.options },
      oosRoles: { selected: this.isOOSRoleSelected, options: this.oosRole?.options },
      documentRoles: { selected: this.isDocumentRoleSelected, options: this.documentRole?.options },
      trainingUserRoles: { selected: this.isTrainingUserRoleSelected, options: this.trainingUserRole?.options },
      authorCategoires: { selected: this.isAuthorCategoiresSelected, options: this.authorCategoires?.options },
      reviewAndAppCateg: { selected: this.isReviewAndAppCategSelected, options: this.reviewAndAppCateg?.options },
      ownerCategories: { selected: this.isOwnerCategoriesSelected, options: this.ownerCategories?.options },
      formAndLogsRoles: { selected: this.isFormAndLogsRolesSelected, options: this.formAndLogsRoles?.options },
      businessProcessRoles: { selected: this.isBusinessProcessRolesSelected, options: this.businessProcessRoles?.options }
    };

    const target = config[value];

    if (!target?.options) return;

    target.options.forEach((item: MatOption) =>
      target.selected ? item.select() : item.deselect()
    );

  }
  onStatusCodeSelectAll(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isStatusSearchSelected = this.searchByStatusDropdown.length == this.statusCodeValue.length;
      })
    }
  }


  onFunctionalRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isfunctionRoleSelected = this.commonRolesDropdown.length == this.funcRoles.length;
      })
    }
  }
  onQualityRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isQualityRoleSelected = this.qualityRoleDropdown.length == this.qualityUserRoles.length;
      })
    }
  }
  onCRRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isCRRoleSelected = this.changeRequestRolesDropdown.length == this.crRoles.length;
      })
    }
  }

  onCAPARolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isCAPARoleSelected = this.capaRolesDropdown.length == this.capaRoles.length;
      })
    }
  }

  ondeviationRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isDeviationRoleSelected = this.deviationRolesDropdown.length == this.dvRoles.length;
      })
    }
  }

  onAuditRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isAuditRoleSelected = this.auditRolesDropdown.length == this.auRoles.length;
      })
    }
  }

  onCustomerCompRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isCustomerCompRoleSelected = this.customerComplaiesRolesDropdown.length == this.ccRoles.length;
      })
    }
  }

  onIncidentRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isIncidentRoleSelected = this.incidentRolesDropdown.length == this.inRoles.length;
      })
    }
  }
  onQIRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isQIRoleSelected = this.qiRolesDropdown.length == this.qiRoles.length;
      })
    }
  }
  onOOSRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isQIRoleSelected = this.oosRolesDropdown.length == this.oosRoles.length;
      })
    }
  }
  onDocumentRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isDocumentRoleSelected = this.documentsRolesDropdown.length == this.documentUserRoles.length;
      })
    }
  }
  ontrainingUserRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isTrainingUserRoleSelected = this.trainingsRolesDropdown.length == this.trainingUserRoles.length;
      })
    }
  }
  onAuthorCategoiresUserRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isAuthorCategoiresSelected = this.TrainingCategorySubgroupsDropdown.length == this.trainingAuthorCategories.length;
      })
    }
  }
  onReviewAndAppCategUserRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isReviewAndAppCategSelected = this.TrainingCategorySubgroupsDropdown.length == this.trainingReviewerApproverCategories.length;
      })
    }
  }
  onOwnerCategoriesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isOwnerCategoriesSelected = this.TrainingCategorySubgroupsDropdown.length == this.trainingOwnerCategories.length;
      })
    }
  }

  onFormAndLogsRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isFormAndLogsRolesSelected = this.formsLogsRolesDropdown.length == this.formsLogsUserRoles.length;
      })
    }
  }

  onBusinessProcessRolesSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.isBusinessProcessRolesSelected = this.bpRolesDropdown.length == this.bpUserRoles.length;
      })
    }
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
    this.labelcall();
  };

  public getStyle(key: any, list: any, i: number): { [klass: string]: any } {
    const value = list[key.columnsListarray];
    const isStatus = key.columnsListarray === 'USER_STATUS';

    // Default colors
    let color = '#0f3659';
    let background = '';
    let border = '';

    if (isStatus) {
      const text = String(value || '');

      if (/(Inactive)/i.test(text) || /(User Deactivation Rejected)/i.test(text)) {
        color = '#FF3A29';
        background = '#FF3A291A';
        border = '0.75px solid #FF3A29';
      } else if (/(Deactivation Approval Pending)/i.test(text)) {
        color = '#FF8900';
        background = '#FF89001A';
        border = '0.75px solid #FF8900';
      } else if (/(Active)/i.test(text)) {
        color = '#00E58F';
        background = '#00E58F1A';
        border = '0.75px solid #00E58F';
      } else if (/(User Deactivated)/i.test(text)) {
        background = '#005C8A1A';
        border = '0.75px solid #005C8A';
      } else {
        border = '0.75px solid #0f3659';
      }
    } else if (i === 0) {
      color = '#07426A';
    }

    return {
      color,
      background,
      border,
      'font-family': isStatus ? 'Poppins' : '',
      'border-radius': '6px',
      padding: '3px 9px'
    };
  }

  public sendForApprovalButton(): boolean {
    if (this.visibleEditButton && this.oneQmsUsersFieldData.isUserDeactivated) {
      return this.oneQmsUsersFieldData.userStatus === 'Active' || this.oneQmsUsersFieldData.userStatus === 'Inactive' || this.oneQmsUsersFieldData.userStatus === 'User Deactivation Rejected';
    } else {
      return false;
    }
  }

  @ViewChild('pendingActivitiesPopup', { static: true }) pendingActivitiesPopup: TemplateRef<any>;
  private visiblePendingActivitiesPopup: MatDialogRef<TemplateRef<any>>;

  private readonly pendingActivitiesPopupConfig: MatDialogConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  pendingActivitiesGridLength: number = 0;
  public openPendingActivitiesPopup(userId: number) {
    this.visiblePendingActivitiesPopup = this.dialog.open(this.pendingActivitiesPopup, this.pendingActivitiesPopupConfig);
    this.getCall(userId);
  }

  public closePendingActivitiesPopup() {
    this.visiblePendingActivitiesPopup.close();
  }


  gridConfig: DynamicGridConfig = {} as any;
  gridClause: DynamicGridClauses = {};
  gridTrail: DynamicGridTrail = {} as any;
  gridReport: DynamicGridReport = {} as any;
  gridSettings: DynamicGridSettings = {} as any;

  getCall(userId: number) {
    this.gridConfig = {
      gridName: 'PENDING_TASKS',
      groupId: 0,
      showAddButton: false,
      showEditIcon: false,
      showDeleteIcon: false,
      showReorderButton: false,
      showAuditTrail: false,
      buttonsTooltipSubName: '',
    }

    this.gridClause = {
      pendingActivityUserId: userId,
    }

    this.gridTrail = {
      gridName: "PENDING_TASKS",
      refKey: 'PENDING_WITH_USERS',
      trailName: "Pending activities of " + this.oneQmsUsersFieldData.userName
    }

    this.gridReport = {
      reportName: "Pending activities of " + this.oneQmsUsersFieldData.userName,
      reportType: 'Dynamic',
      excludeGroupId: true,
    }

    this.gridSettings = {
      module: 'User Management',
      groupId: 0
    }
  }

  onGridRefresh(event: any) {
    this.pendingActivitiesGridLength = event.length
  }

}
